"use client";
import { addNextjsError } from "@datadog/browser-rum-nextjs";
import { Button } from "@workspace/frontend-ui";
import { useEffect } from "react";

type Props = {
  error: Error & { digest?: string };
  reset: () => void;
  title?: string;
  description?: string;
};

const ErrorBoundaryFallback: FC<Props> = ({
  error,
  reset,
  title = "We could not load this page",
  description = "The issue has been reported automatically. Please try again.",
}) => {
  useEffect(() => {
    addNextjsError(error);
  }, [error]);

  return (
    <div className="mx-auto my-10 w-full max-w-2xl px-4 lg:my-16">
      <div className="rounded-xl border bg-background p-8 text-center shadow-sm lg:p-10">
        <p className="mb-2 text-xs font-medium uppercase tracking-wide text-muted-foreground">
          Temporary issue
        </p>
        <h2 className="mb-3 text-3xl font-semibold leading-tight text-foreground">
          {title}
        </h2>
        <p className="mx-auto mb-6 max-w-xl text-base text-muted-foreground">
          {description}
        </p>
        {error.digest && (
          <p className="mb-6 text-xs text-muted-foreground">
            Reference: {error.digest}
          </p>
        )}
        <div className="mx-auto w-full max-w-56">
          <Button className="w-full" size="xl" onClick={reset}>
            Try again
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundaryFallback;
